import { CircularProgress } from '@mui/material';

export function LoadingSpinner() {
  return <CircularProgress color="inherit" size={20} />;
}

export default LoadingSpinner;
